import { Role } from '@guiker/permissions'

import { DocumentActions } from '../document-actions'
import { DocumentRoleNames } from '../role-names'

export const SignerRole: Role = {
  name: DocumentRoleNames.SIGNER,
  permissions: [{ action: DocumentActions.SignDocument }, { action: DocumentActions.ViewDocument }],
}
